import { Alert, Box, Button, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export const ErrorPage = ({ message }: { message?: string }) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ maxWidth: 640, mx: "auto", p: 3 }}>
      <Stack spacing={2} alignItems="flex-start">
        <Typography variant="h5" component="h1">
          {t("errors.title")}
        </Typography>
        <Alert severity="error" sx={{ width: "100%" }}>
          {message ?? t("errors.body")}
        </Alert>
        <Button
          variant="outlined"
          onClick={() => {
            window.location.reload();
          }}
        >
          {t("errors.reload")}
        </Button>
      </Stack>
    </Box>
  );
};
